export default __webpack_public_path__ + "static/media/living-room.48f4aec1.jpg";